import { useMemo } from 'react';
import { useAppSelector } from '@redux/store';

const useMaxProduction = (recipe?: Record<string, number>): number => {
  const storage = useAppSelector((state) => state.user.user?.storage);

  return useMemo(() => {
    if (storage && recipe) {
      let max: number | undefined;
      for (const resource in recipe) {
        const value = recipe[resource];

        if (resource in storage) {
          const resourceStorage = storage[resource]?.value as number;
          const residue = resourceStorage % value;
          const quantity = (resourceStorage - residue) / value;
          max = max === undefined || max > quantity ? quantity : max;
        } else {
          return 0;
        }
      }

      return max as number;
    } else {
      return 0;
    }
  }, [storage, recipe]);
};

export { useMaxProduction };
